import axios from '../configs/axios';
import { serializeQuery } from '../utility/helpers/serializeQuery';

class ReferralRepository {
    async getById(referralId, payload) {
        const response = await axios.get(
            `case/by-id/${referralId}${
                !!payload ? `?${serializeQuery(payload)}` : ''
            }`,
        );
        return response;
    }

    async createReferral(payload) {
        const response = await axios.post('case/create', payload);
        return response;
    }

    async updateReferralStatus(referralId, payload) {
        const response = await axios.put(
            `case/update_status/${referralId}`,
            payload,
        );
        return response;
    }

    async createOtherServiceReferral(payload) {
        return await axios.post('case/create_other_service_referral', payload);
    }

    async createLrsReferral(payload) {
        const response = await axios.post('case/create_lrs', payload);
        return response;
    }

    async updateLrsReferral(referralId, payload) {
        const response = await axios.put(
            `case/update_lrs/${referralId}`,
            payload,
        );
        return response;
    }

    async createLead(payload) {
        const response = await axios.post('case/create_lead', payload);
        return response;
    }

    async resendLrsCreateEmail(referralId, payload) {
        const response = await axios.put(
            `case/resend_lrs_email/${referralId}`,
            payload,
        );

        return response;
    }

    async createECBAReferral(payload) {
        const response = await axios.post('case/create_ecba', payload);
        return response;
    }

    async resendECBANewReferralNotificatons(referralId, payload) {
        const response = await axios.put(
            `case/resend_ebca_new_referral_notifications/${referralId}`,
            payload,
        );

        return response;
    }

    async createLFPReferral(payload) {
        const response = await axios.post('case/create_lfp', payload);
        return response;
    }

    async createLFPLead(payload) {
        const response = await axios.post('case/create_lfp_lead', payload);
        return response;
    }

    async newReferralNotificationsToClient(referralId, payload) {
        const response = await axios.post(
            `case/new_referral_notifications_to_client/${referralId}`,
            payload,
        );
        return response;
    }

    async searchReferrals(searchParams) {
        const response = await axios.post('case/referral/list', searchParams);
        return response;
    }

    async searchReferralsNew(searchParams) {
        const response = await axios.post(
            'case/referral/list_new',
            searchParams,
        );
        return response;
    }

    async getRefferalsLeadStatuses(searchParams) {
        const response = await axios.post(
            'case/referral/leadStatuses',
            searchParams,
        );
        return response;
    }

    async searchLFPReferrals(searchParams) {
        const response = await axios.post(
            'case/referral/list_lfp',
            searchParams,
        );
        return response;
    }

    async cancelReferral(payload) {
        const response = await axios.post('case/referral/cancel', payload);
        return response;
    }

    async referralAddFeedback(payload) {
        const response = await axios.post('case/referral/feedback', payload);
        return response;
    }

    async getReferralsFeedbacksByUserId(userId) {
        const response = await axios.get(`case/feedbacks/by-user/${userId}`);
        return response;
    }

    async createReferralNote(payload) {
        const response = await axios.post(
            '/case/referral/createReferralNote',
            payload,
        );
        return response;
    }

    async updateReferralNote(referralNoteId, payload) {
        const response = await axios.put(
            `/case/referral/updateReferralNote/${referralNoteId}`,
            payload,
        );
        return response;
    }

    async deleteReferralNote(referralNoteId) {
        const response = await axios.delete(
            `/case/referral/updateReferralNote/${referralNoteId}`,
        );
        return response;
    }

    async checkReferralToken(token) {
        const response = await axios.get(`case/check/referralToken/${token}`);
        return response;
    }

    async getReferralByToken(token) {
        const response = await axios.get(`case/referralByToken/${token}`);
        return response;
    }

    async completeReferral(referralId) {
        const response = await axios.put(
            `case/referral/complete/${referralId}`,
        );
        return response;
    }

    async completeReferralWithToken(payload) {
        const response = await axios.put(
            'case/referral/completeWithToken',
            payload,
        );
        return response;
    }

    async updateReferralWithToken(referralToken, payload) {
        const response = await axios.put(
            `case/referral/updateReferralWithToken/${referralToken}`,
            payload,
        );
        return response;
    }

    async declineReferral(referralId, payload) {
        const response = await axios.put(
            `case/referral/decline/${referralId}`,
            payload,
        );
        return response;
    }

    async declineReferralWithToken(payload) {
        const response = await axios.put(
            'case/referral/declineWithToken',
            payload,
        );
        return response;
    }

    async checkFlaggedReferral(status, payload) {
        const response = await axios.get(
            `case/check/flaggefByStatus/${status}${
                !!payload ? `?${serializeQuery(payload)}` : ''
            }`,
        );

        return response;
    }

    async getCasesByUser(payload) {
        const response = await axios.get(
            `case/by_user?${serializeQuery(payload)}`,
        );

        return response;
    }

    async uploadCaseFiles(payload) {
        const response = await axios.post('case/files', payload);
        return response;
    }

    async getCaseFiles(referralId, payload) {
        const response = await axios.get(
            `case/files/${referralId}?${serializeQuery(payload)}`,
        );
        return response;
    }

    async shareOrUnshareCaseFile(fileId, payload) {
        const response = await axios.put(`case/files/share/${fileId}`, payload);
        return response;
    }

    async deleteCaseFile(fileId) {
        const response = await axios.delete(`case/files/${fileId}`);
        return response;
    }

    async getReferralActivities(referralId, payload) {
        const response = await axios.get(
            `case/activities/${referralId}?${serializeQuery(payload)}`,
        );
        return response;
    }

    async getReferralTimeline(referralId) {
        const response = await axios.get(`case/timeline/${referralId}`);
        return response;
    }

    async scheduleLrsConsult(referralId, payload) {
        const response = await axios.put(
            `case/lrs_schedule_consult/${referralId}`,
            payload,
        );
        return response;
    }

    async createLrsConsult(payload) {
        const response = await axios.post('case/lrs_consult', payload);
        return response;
    }

    async rescheduleLrsConsult(appointmentId, payload) {
        const response = await axios.post(
            `case/lrs_reschedule_consult/${appointmentId}`,
            payload,
        );
        return response;
    }

    async addCaseUsers(payload) {
        const response = await axios.post('case/add_case_user', payload);
        return response;
    }

    async getCaseUsers(referralId, payload) {
        const response = await axios.get(
            `case/case_user/${referralId}${
                !!payload ? `?${serializeQuery(payload)}` : ''
            }`,
        );
        return response;
    }

    async deleteCaseUser(referralId, userId) {
        const response = await axios.delete(
            `case/delete_case_user/${referralId}`,
            {
                data: {
                    userId,
                },
            },
        );

        return response;
    }

    // async createForwardingFeePayment(payload) {
    //     const response = await axios.post('case/forwardingFeePayment', payload);
    //     return response;
    // }

    // async completeForwardingFeePayment(paymentId, payload) {
    //     const response = await axios.put(
    //         `case/forwardingFeePayment/${paymentId}`,
    //         payload,
    //     );
    //     return response;
    // }

    // async updateForwardingFeePaymentStatus(paymentId, payload) {
    //     const response = await axios.put(
    //         `case/forwardingFeePayment/status/${paymentId}`,
    //         payload,
    //     );
    //     return response;
    // }

    async deleteForwardingFeePayment(paymentId) {
        const response = await axios.delete(
            `case/forwardingFeePayment/${paymentId}`,
        );

        return response;
    }

    // async getForwardingFeePayment(paymentId) {
    //     const response = await axios.get(
    //         `case/forwardingFeePayment/${paymentId}`,
    //     );
    //     return response;
    // }

    // async getForwardingFeePayments(payload) {
    //     const response = await axios.get(
    //         `case/forwardingFeePayments?${serializeQuery(payload)}`,
    //     );
    //     return response;
    // }

    // async getReferralPaymentsTotalAmount(referralId, excludePaymentId) {
    //     const response = await axios.get(
    //         `case/referral/casePaymentsTotalAmount/${referralId}${
    //             !!excludePaymentId
    //                 ? `?excludePaymentId=${excludePaymentId}`
    //                 : ''
    //         }`,
    //     );
    //     return response;
    // }

    async createReferralFeePayment(payload) {
        const response = await axios.post(
            'case/referral/referralFeePayment',
            payload,
        );
        return response;
    }

    async createReferralPayment(payload) {
        const response = await axios.post(
            'case/referral/referralPayment',
            payload,
        );
        return response;
    }

    async updateReferralPayment(paymentId, payload) {
        const response = await axios.put(
            `case/referral/referralPayment/${paymentId}`,
            payload,
        );
        return response;
    }

    async getReferralPayments(payload) {
        const response = await axios.get(
            `case/referral/referralPayments?${serializeQuery(payload)}`,
        );
        return response;
    }

    async getReferralPayment(paymentId) {
        const response = await axios.get(
            `case/referral/referralPayment/${paymentId}`,
        );
        return response;
    }

    async refundReferralFeePayment(paymentId) {
        const response = await axios.put(
            `case/referral/referralFeePayment/refund/${paymentId}`,
        );
        return response;
    }

    async captureReferralFeePayment(paymentId) {
        const response = await axios.put(
            `case/referral/referralFeePayment/capture/${paymentId}`,
        );
        return response;
    }

    async deleteReferralFeePayment(paymentId) {
        const response = await axios.delete(
            `case/referral/referralPayment/${paymentId}`,
        );

        return response;
    }

    async sendClientSurvey(payload) {
        return await axios.post('case/clientSurvey', payload);
    }

    async createLeadUpdate(payload) {
        return await axios.post('case/leadUpdate', payload);
    }

    async getLeadUpdates(leadId) {
        return await axios.get(`case/leadUpdates/${leadId}`);
    }

    async closeReferrals(payload) {
        return await axios.put('case/close-referrals', payload);
    }

    async getReferralByIdForSurvey(referralId) {
        return await axios.get(`case/for_survey/${referralId}`);
    }

    async referralGlobalSearch(searchParams) {
        const response = await axios.get('case/global_search', {
            params: searchParams,
        });
        return response;
    }

    async fetchMatters(searchParams) {
        const response = await axios.get('case/matters', {
            params: searchParams,
        });
        return response;
    }
}

export default new ReferralRepository();
